"use strict";function KeySequence() {
  this.aS_ = Object.create(null);
}

KeySequence.prototype.aP_ = function (key) {
  var lookup = this.aS_;

  if (lookup[key]) {
    return key + "_" + lookup[key]++;
  }

  lookup[key] = 1;
  return key;
};

module.exports = KeySequence;